import { Component, OnInit } from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {GlobalService} from '../../global.service';
import {AuthenticationService} from '../../authentication.service';

@Component({
  selector: 'elastic-yearlyrecap',
  templateUrl: './yearlyrecap.component.html',
  styleUrls: ['./yearlyrecap.component.scss']
})
export class YearlyrecapComponent implements OnInit {

  data: any;

  constructor(private http: HttpClient, private globalService: GlobalService, private auth: AuthenticationService) { }

  ngOnInit() {
    this.http.get(this.globalService.apiUrl + '/statistics/recap/' + this.auth.getUserId() + '/2024' ).subscribe( (data) => {
      this.data = data;
    });
  }

}
